module.exports = __webpack_public_path__ + "static/media/parkguell-final1.1b47a335.png";